export const categoryData=[
    "Abrasive Products",
    "Accounting, Tax Preparation, Bookkeeping, And Payroll",
    "Adhesives",
    "Advertising And Public Relations",
    "Agriculture And Forestry Support",
    "Air And Gas Compressors",
    "Air Conditioning, Refrigeration, And Warm Air Heating Equipment",
    "Air Purification And Ventilation Equipment",
    "Air Transport",
    "Aircraft",
    "Aircraft Engines And Parts",
    "All Other Converted Paper Products",
    "All Other Food And Drinking Places",
    "All Other Foods",
    "All Other Forging, Stamping, And Sintering",
    "Aluminum",
    "Aluminum Products",
    "Ambulances",
    "Ammunition, Arms, Ordnance, And Related Accessories",
    "Amusement Parks And Arcades",
    "Analytical Laboratory Instruments",
    "Animal Farms And Aquaculture Ponds (Except Cattle And Poultry)",
    "Architectural, Engineering, And Related Services",
    "Asphalt Pavement",
    "Asphalt Shingles",
    "Audio And Video Equipment",
    "Automatic Controls For Hvac And Refrigeration Equipment",
    "Automobiles",
    "Ball And Roller Bearings",
    "Blood Sugar, Pregnancy, And Other Diagnostic Test Kits",
    "Boats",
    "Books",
    "Books, Newspapers, Magazines, And Other Print Media",
    "Bread And Other Baked Goods",
    "Breakfast Cereals",
    "Breweries And Beer",
    "Buildings And Dwellings Services",
    "Business Support",
    "Cable And Subscription Programming",
    "Carbon And Graphite Products",
    "Cardboard",
    "Cardboard Containers",
    "Carpets And Rugs",
    "Cast Iron And Steel",
    "Cattle Ranches And Feedlots",
    "Cement",
    "Cheese",
    "Chemicals (Except Basic Chemicals, Agrichemicals, Polymers, Paints, Pharmaceuticals, Soaps, Cleaning Compounds)",
    "Child Day Care",
    "Civic, Social, Professional, And Similar Organizations",
    "Clay And Ceramic Products",
    "Clothing",
    "Coal",
    "Coffee And Tea",
    "Colleges, Universities, Junior Colleges, And Professional Schools",
    "Commercial Equipment Rental",
    "Commercial Machinery Repair",
    "Commercial Structures, Including Farm Structures",
    "Communication And Energy Wire And Cable",
    "Communications Equipment",
    "Community Food, Housing, And Other Relief Services, Including Rehabilitation Services",
    "Company And Enterprise Management",
    "Compressed Gases",
    "Computer Storage Device Readers",
    "Computer Systems Design",
    "Computer Terminals And Other Computer Peripheral Equipment",
    "Computers",
    "Concrete Pipe, Bricks, And Blocks",
    "Construction Machinery",
    "Consumer Goods And General Rental Centers",
    "Cookies, Crackers, Pastas, And Tortillas",
    "Copper, Nickel, Lead, And Zinc",
    "Corn Products",
    "Couriers And Messengers",
    "Curtains And Linens",
    "Custom Computer Programming",
    "Custom Metal Rolls",
    "Cut Stone And Stone Products",
    "Cutlery And Handtools",
    "Cutting And Machine Tool Accessory, Rolling Mill, And Other Metalworking Machines",
    "Dairies",
    "Data Processing And Hosting",
    "Dental Equipment And Supplies",
    "Dental Laboratories",
    "Dentists",
    "Dimensional Stone",
    "Directory, Mailing List, And Other Publishers",
    "Distilleries And Spirits",
    "Dog And Cat Food",
    "Dolls, Toys, And Games",
    "Drinking Water And Wastewater Treatment",
    "Dry, Condensed, And Evaporated Dairy",
    "Dry-Cleaning And Laundry",
    "Electricity",
    "Electromedical Apparatuses",
    "Electronic Equipment Repair And Maintenance",
    "Electronic Capacitors, Resistors, Coils, Transformers, Connectors And Other Components (Except Semiconductors And Printed Circuit Assemblies)",
    "Elementary And Secondary Schools",
    "Employment Services",
    "Environmental And Other Technical Consulting Services",
    "External Hard Drives, Cds, Other Storage Media",
    "Fabric",
    "Fabricated Pipe And Pipe Fittings",
    "Facilities Support",
    "Farm Machinery And Equipment",
    "Federal Government (Defense)",
    "Federal Government (Nondefense)",
    "Federal Government Enterprises",
    "Fertilizers",
    "Fiber, Yarn, And Thread",
    "Finished And Coated Fabric",
    "Flavored Drink Concentrates",
    "Flours And Malts",
    "Fluid Meters And Counting Devices",
    "Fluid Milk And Butter",
    "Food And Beverage Stores",
    "Fresh Fruits And Tree Nuts",
    "Fresh Soybeans, Canola, Flaxseeds, And Other Oilseeds",
    "Fresh Vegetables, Melons, And Potatoes",
    "Fresh Wheat, Corn, Rice, And Other Grains",
    "Frozen Food",
    "Fruit And Vegetable Preservation",
    "Full-Service Restaurants",
    "Funds, Trusts, And Financial Vehicles",
    "Funerary Services",
    "Gambling Establishments (Except Casino Hotels)",
    "Gaskets, Seals, Musical Instruments, Fasteners, Brooms, Brushes, Mop And Other Misc. Goods",
    "Gasoline, Fuels, And By-Products Of Petroleum Refining",
    "General Merchandise Stores",
    "Glass And Glass Products",
    "Golf Courses, Marinas, Ski Resorts, Fitness And Other Rec Centers And Industries",
    "Grantmaking, Giving, And Social Advocacy Organizations",
    "Greenhouse Crops, Mushrooms, Nurseries, And Flowers",
    "Ground Or Treated Minerals And Earth",
    "Guided Missiles And Space Vehicles",
    "Health Care Buildings",
    "Healthcare Practitioners (Except Physicians And Dentists)",
    "Heating Equipment Other Than Warm Air Furnaces",
    "Heavy Duty Trucks",
    "Heavy Gauge Metal Tanks",
    "Highways, Streets, And Bridges",
    "Home Cooking Appliances",
    "Home Furniture - Cabinets And Non-Wood, Nonupholstered",
    "Home Furniture - Upholstered",
    "Home Furniture - Wood, Nonupholstered",
    "Home Healthcare",
    "Home Laundry Machines",
    "Home Refrigerators And Freezers",
    "Hospitals",
    "Hotels And Campgrounds",
    "Household Employees",
    "Household Goods Repair",
    "Housing",
    "Hydraulic Pumps, Motors, Cylinders And Actuators",
    "Ice Cream And Frozen Desserts",
    "Independent Artists, Writers, And Performers",
    "Individual And Family Services",
    "Industrial Molds",
    "Industrial Process Furnaces And Ovens",
    "Industrial Process Variable Instruments",
    "Ink And Ink Cartridges",
    "Institutional Furniture",
    "Insurance Agencies And Brokerages",
    "Insurance Carriers",
    "Internet Publishing And Broadcasting",
    "Investigation And Security",
    "Investment Advice, Portfolio Management, And Other Financial Advising Services",
    "Iron, Gold, Silver, And Other Metal Ores",
    "Irradiation Apparatuses",
    "Jewelry And Silverware",
    "Laminated Plastic Plates And Shapes",
    "Lawn And Garden Equipment",
    "Leather",
    "Legal Services",
    "Lessors Of Nonfinancial Intangible Assets",
    "Lids, Jars, Bottle Caps, Other Metal Closures And Crowns",
    "Light Bulbs",
    "Light Fixtures",
    "Light Gauge Metal Cans, Boxes, And Containers",
    "Lime And Gypsum Products",
    "Limited-Service Restaurants",
    "Lumber And Treated Lumber",
    "Machine Shops",
    "Machinery For The Paper, Textile, Food Or Other Industries (Except Semiconductor Machinery)",
    "Magazines And Journals",
    "Major Home Appliances (Except Ovens, Stoves, Refrigerators And Laundry Machines)",
    "Management Consulting",
    "Manufacturing Buildings",
    "Marketing Research And All Other Miscellaneous Professional, Scientific, And Technical Services",
    "Material Handling Equipment",
    "Mattresses, Blinds And Shades",
    "Mechanical Power Transmission Equipment",
    "Medical Laboratories",
    "Medicinal And Botanical Ingredients",
    "Metal Coatings, Engravings, And Heat Treatments",
    "Metal Cutting And Forming Machine Tools",
    "Metal Hinges, Keys, Lock, And Other Hardware",
    "Metal Pipe Fittings, Ball And Roller Bearings, Industrial Patterns, Metal Bath Fixtures, Other Misc. Fabricated Metals",
    "Metal Plumbing Drains, Faucets, Valves, And Other Fittings",
    "Metal Structural Products",
    "Metal Windows, Doors, And Architectural Products",
    "Military Armored Vehicles And Tanks",
    "Mineral Wool",
    "Mining And Oil, Gas Field Machinery",
    "Monetary Authorities And Depository Credit Intermediation",
    "Motor Homes",
    "Motor Vehicle Steering, Suspension Components (Except Spring), And Brake Systems",
    "Motorcycle, Bicycle, And Parts",
    "Motors And Generators",
    "Movies And Film",
    "Multifamily Homes",
    "Museums, Historical Sites, Zoos, And Parks",
    "Natural Gas",
    "Navigation Instruments",
    "News Syndicates, Libraries, Archives, Internet Publishing And All Other Information Services",
    "Newspapers",
    "Noncomparable Imports",
    "Nondepository Credit Intermediation And Related Activities",
    "Nonferrous Metal Casts",
    "Nonresidential Building Repair And Maintenance",
    "Nursing And Community Care Facilities",
    "Office Administration",
    "Office Furniture And Custom Architectural Woodwork And Millwork",
    "Office Machinery",
    "Office Supplies (Not Paper)",
    "Ophthalmic Goods",
    "Optical Instruments And Lenses",
    "Other Aircraft Parts",
    "Other Animal Food",
    "Other Basic Inorganic Chemicals",
    "Other Basic Organic Chemicals",
    "Other Computer Related Services, Including Facilities Management",
    "Other Concrete Products",
    "Other Educational Services",
    "Other Engine Equipment",
    "Other Miscellaneous Electrical Equipment And Components",
    "Other Nonmetallic Mineral Products",
    "Other Nonresidential Structures",
    "Other Petroleum And Coal Products",
    "Other Plastic Products",
    "Other Primary Nonferrous Metals",
    "Other Real Estate",
    "Other Residential Structures",
    "Other Retail",
    "Other Rubber Products",
    "Other Secondary Nonferrous Metal Products",
    "Other Support Activities For Mining",
    "Other Support Services",
    "Other Textiles",
    "Other Transportation Equipment",
    "Other Vehicle Parts",
    "Outpatient Healthcare",
    "Packaged Meat (Except Poultry)",
    "Packaged Poultry",
    "Packaging Machinery",
    "Paints And Coatings",
    "Paper",
    "Paper Bags And Coated Paper",
    "Passenger Ground Transport",
    "Performances",
    "Pesticides",
    "Pet Care, Photofinishing, Parking And Other Sundry Services",
    "Petrochemicals",
    "Pharmaceutical Products (Pills, Powders, Solutions, Etc.)",
    "Photographers",
    "Photography And Photocopying Equipment",
    "Physicians",
    "Pickup Trucks, Vans, And Suvs",
    "Pipeline Transport",
    "Plastic Bags, Films, And Sheets",
    "Plastic Bottles",
    "Plastic Pipe, Fittings, And Sausage Casings",
    "Plastics",
    "Plastics And Rubber Industry Machinery",
    "Plywood And Veneer",
    "Polystyrene Foam Products",
    "Postal Service",
    "Poultry Farms",
    "Power Boilers And Heat Exchangers",
    "Power Tools",
    "Primary Batteries",
    "Primary Copper",
    "Primary Iron, Steel, And Ferroalloy Products",
    "Printed Circuit And Electronic Assembly",
    "Printing Support",
    "Promoters And Agents",
    "Propulsion Units And Parts For Space Vehicles And Guided Missiles",
    "Pumps And Pumping Equipment",
    "Radio And Television",
    "Rail Transport",
    "Railroad Rolling Stock",
    "Ready-Mix Concrete",
    "Refined Vegetable, Olive, And Seed Oils",
    "Relay And Industrial Controls",
    "Religious Organizations",
    "Residential Building Repair And Maintenance",
    "Residential Mental Retardation, Mental Health, Substance Abuse And Other Facilities",
    "Rest Of The World Adjustment",
    "Rubber And Plastic Belts And Hoses",
    "Rubber Tires",
    "Salons And Barber Shops",
    "Sand, Gravel, Clay, Phosphate, Other Nonmetallic Minerals",
    "Sanitary Paper (Tissues, Napkins, Diapers, Etc.)",
    "Satellite, Telecommunications Resellers, And All Other Telecommunications",
    "Scenic And Sightseeing Transportation And Support Activities For Transportation",
    "Schools And Vocational Buildings",
    "Scientific Research And Development",
    "Screws, Nuts, And Bolts",
    "Seafood",
    "Seasonings And Dressings",
    "Secondary Copper Products",
    "Secondary Steel Products",
    "Securities And Commodities Brokerage And Exchanges",
    "Semiconductor Machinery",
    "Semiconductors",
    "Shelving And Lockers",
    "Ships And Ship Repair",
    "Signal Testing Instruments",
    "Signs",
    "Single-Family Homes",
    "Small Electrical Appliances",
    "Snack Foods",
    "Soap And Cleaning Compounds",
    "Soft Drinks, Bottled Water, And Ice",
    "Software",
    "Sound Recording",
    "Special Tools, Dies, Jigs, And Fixtures",
    "Specialized Design",
    "Specialty Transformers",
    "Speed Changers, Industrial High-Speed Drives, And Gears",
    "Sporting And Athletic Goods",
    "Sports",
    "Springs And Wires",
    "State And Local Government",
    "State And Local Government Enterprises",
    "Stationery",
    "Storage Batteries",
    "Sugar, Candy, And Chocolate",
    "Surgical And Medical Instruments",
    "Surgical Appliance And Supplies",
    "Switchgear And Switchboards",
    "Synthetic Dyes And Pigments",
    "Synthetic Rubber And Artificial And Synthetic Fibers",
    "Telecommunications",
    "Telephones",
    "Timber And Raw Forest Products",
    "Tobacco Products",
    "Tobacco, Cotton, Sugarcane, Peanuts, Sugar Beets, Herbs And Spices, And Other Crops",
    "Toiletries",
    "Transmission And Power Train Parts",
    "Travel Arrangement And Reservation",
    "Travel Trailer And Campers",
    "Truck Trailers",
    "Truck Transport",
    "Turbines And Turbine Generator Sets",
    "Unrefined Oil And Gas",
    "Urethane And Other Foam Products",
    "Used And Secondhand Goods",
    "Utilities Buildings And Infrastructure",
    "Vaccines And Other Biological Medical Products",
    "Valve And Fittings (Except For Plumbing)",
    "Vegetable Oils And By-Products",
    "Vehicle Bodies",
    "Vehicle Electrical And Electronic Equipment",
    "Vehicle Engines And Engine Parts",
    "Vehicle Metal Stamping",
    "Vehicle Rental And Leasing",
    "Vehicle Repair",
    "Vehicle Seating And Interior Trim (Upholstery)",
    "Vehicles And Parts Sales",
    "Vending, Commercial Laundry, And Other Commercial And Service Industry Machinery",
    "Veneer, Plywood, And Engineered Wood",
    "Veterinarians",
    "Warehousing",
    "Waste Management And Remediation",
    "Watches, Clocks, And Other Measuring And Controlling Devices",
    "Water Transport (Boats, Ships, Ferries)",
    "Welding And Soldering Equipment, Scales And Balances, And Other General Purpose Machinery",
    "Well Drilling",
    "Wholesale Trade",
    "Wild-Caught Fish And Game",
    "Wineries And Wine",
    "Wireless Communications",
    "Wireless Telecommunications",
    "Wiring Devices",
    "Wood Kitchen Cabinets And Countertops",
    "Wood Pulp",
    "Wooden Windows, Door, And Flooring"
  ]
  